// THIS SHOULD BE DEPRECATED IN FAVOR OF VERTICALS STYLED
import React from "react";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import styled from "@emotion/styled";
import { verticalServices } from "@resourcehub/resourcehub-shared";
import AnchorFallback from "../AnchorFallback/AnchorFallback";
import { isCombinedVertical } from "../../../services/combinedVerticals";
import { verticalType } from "../../../types";

const TitleDiv = styled.h2`
    label: TitleDiv;

    font-family: helvetica_bold, sans-serif;
    font-size: 36px;
    font-weight: 700;
    line-height: 45px;
    text-align: center;
`;
const VerticalsContainerDiv = styled.div`
    label: VerticalsContainerDiv;

    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 60px auto;
    max-width: 1135px;
    top: 135px;
`;
const VerticalDiv = styled.div`
    label: VerticalDiv;

    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    list-style: none;
    margin: 0 auto;
    max-width: 360px;
    padding: 0 20px;
    text-align: center;
    h3 {
        font-family: helvetica_bold, sans-serif;
        padding-top: 23px;
        font-size: 23px;
    }
`;
const BorderTopDiv = styled.div`
    label: BorderTopDiv;

    .border-top {
        @media (max-width: 1080px) {
            height: 200px;
        }
    }
`;

const BorderBottomDiv = styled.div`
    label: BorderBottomDiv;

    .border-bottom {
        @media (max-width: 1080px) {
            height: 370px;
        }
        @media (max-width: 750px) {
            height: 300px;
        }
        @media (max-width: 450px) {
            height: 210px;
        }
    }
`;

const Verticals = ({ vertical, copyData, data, pageData }) => {
    const combinedVerticals = isCombinedVertical(copyData.market);
    const linkData = verticalServices.deriveLinks(vertical, copyData, combinedVerticals, data);
    const topicsClass = pageData ? "topics" : "topics topics--withoutBackground";
    return (
        <section className={topicsClass}>
            <BorderTopDiv />
            <TitleDiv>{pageData ? pageData.verticals_title : copyData.verticals_title}</TitleDiv>
            <VerticalsContainerDiv>
                <VerticalDiv>
                    <AnchorFallback useLink={combinedVerticals} destination={linkData.linkOne}>
                        <Img fixed={linkData.imageOne} />
                        <h3>{linkData.textOne}</h3>
                        {pageData && <p>{pageData.training_description}</p>}
                    </AnchorFallback>
                </VerticalDiv>
                <VerticalDiv>
                    <AnchorFallback useLink={combinedVerticals} destination={linkData.linkTwo}>
                        <Img fixed={linkData.imageTwo} />
                        <h3>{linkData.textTwo}</h3>
                        {pageData && <p>{pageData.education_description}</p>}
                    </AnchorFallback>
                </VerticalDiv>
                <VerticalDiv>
                    <AnchorFallback useLink={combinedVerticals} destination={linkData.linkThree}>
                        <Img fixed={linkData.imageThree} />
                        <h3>{linkData.textThree}</h3>
                        {pageData && <p>{pageData.business_description}</p>}
                    </AnchorFallback>
                </VerticalDiv>
            </VerticalsContainerDiv>
            {pageData && <BorderBottomDiv />}
        </section>
    );
};

Verticals.propTypes = {
    vertical: verticalType.isRequired,
    copyData: PropTypes.shape({
        verticals_title: PropTypes.string.isRequired,
        verticals_subtitle: PropTypes.string.isRequired
    }).isRequired
};

export default Verticals;
